import { Vue, Component } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

// Helpers
import { openWALink } from "@/plugins/subscriptions_helper";

// External components
import OrderPreview from "@/components/subscriptionOrders/OrderPreview/OrderPreview";
import ReactivateSubscription from "@/components/editSubscription/reactivateSubscription/reactivateSubscription";
import ModalAddDocument from "@/components/modalAddDocument/modalAddDocument";

@Component({
  components: { OrderPreview, ReactivateSubscription, ModalAddDocument },
  methods: {
    openWALink,
  },
})
export default class SubscriptionOrdersHome extends Vue {
  @Action action_getCurrentOrder;

  @Getter getSubscription;
  @Getter getCurrentOrder;
  @Getter getUser;
  @Getter getIsUnderMobile;

  @Mutation SPINNER;

  isShowingAddDocumentModal = false;

  async mounted() {
    const { last_order } = this.getSubscription;
    if (last_order) {
      try {
        this.SPINNER(true);
        await this.action_getCurrentOrder(last_order);
      } catch (error) {
        this.$swal({
          title: "Error",
          text: `Error al obtener el último pedido. ${
            error.response && error.response.data && error.response.data.message
          }}`,
        });
      }
    }
    this.SPINNER(false);
    this.setShowDocumentModal();
  }

  setShowDocumentModal() {
    const { document_number, document_type } = this.getUser;
    this.isShowingAddDocumentModal =
      !document_number || !document_number.length || !document_type || !document_type.length;
  }
}
